export default function getLogic(logic = [], choice, row) {
  return logic.filter(term => isLogicForChoice(term, choice));
}

function isLogicForChoice(term, choice) {
  if (choice.none) return term.none;
  if (choice.dont_know) return term.dont_know;
  if (choice.other) return term.other;
  return term.survey_choice_id === choice.id;
}
